module.exports = {
	"name": "Earthen Jar",
	"foodRecommendations": [],
	"address": "311 S 5th Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279102,
		"lng": -83.745884
	},
	"catImage": "greenstar.png"
};


//////////////////
// WEBPACK FOOTER
// ./src/json/earthenjar.json
// module id = 868
// module chunks = 0